// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"de44d962","517":"a2bc079f"}[chunkId] + ".chunk.js";
};